import { render, staticRenderFns } from "./ComplementaryPayrollsCard.vue?vue&type=template&id=f9ad3e80"
import script from "./ComplementaryPayrollsCard.vue?vue&type=script&lang=js"
export * from "./ComplementaryPayrollsCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports